<template>
	<include-header />

	<section id="lab_order">
		<div class="content">
			<div class="contIn">
				<div class="sub_cont">
					<div class="boardTit">주문 관리</div>
					<div class="searchBox">
						<form ref="form_search" id="form_search" @submit.prevent="triggerChildGetModels()">
							<div class="searchRow">
								<!-- <div class="searchCont">
									<label for="dentalOrderNoSearch" class="form-label required">접수번호</label>
									<input type="text" class="form-control" v-model="searchModels.aiorder_no"
										id="dentalOrderNoSearch" placeholder="" @keyup.enter.prevent="triggerChildGetModels()">
								</div> -->
								<div class="searchCont">
									<label for="dentalPartnerSearch" class="form-label required">{{ other_type }}명</label>
									<input type="text" class="form-control" v-model="searchModels.partner"
										id="dentalPartnerSearch" :placeholder="`${other_type}명`" @keyup.enter.prevent="triggerChildGetModels()">
								</div>
								<div class="searchCont">
									<label for="orderDateSearch" class="form-label required">주문일</label>
									<input type="date" class="form-control" id="orderDateSearch"
										v-model="searchModels.orderDateSearch" value="">
									<span class="hyphen">-</span>
									<input type="date" class="form-control" id="orderDateSearch2"
										v-model="searchModels.orderDateSearch2" value="">
								</div>
								<div class="searchCont">
									<label for="patientSearch" class="form-label required">환자명</label>
									<input type="text" class="form-control" id="patientSearch"
										v-model="searchModels.patientSearch" placeholder="환자명" value="" @keyup.enter.prevent="triggerChildGetModels()">
								</div>
								<div class="searchCont">
									<label for="progressSearch" class="form-label required">제작상태</label>
									<select id="progressSearch" v-model="searchModels.progressSearch">
										<option value="">전체</option>
										<option value="ords1">의뢰서접수</option>
										<option value="ords2">의뢰서 확인</option>
										<option value="ords3">출고 완료</option>
										<option value="ords4">주문 취소</option>
									</select>
								</div>
								<div>
									<button type="button" class="search_btn" id="searchBtn" @click.prevent="triggerChildGetModels()">검색</button>
									<button type="button" v-show="isSearchActive" class="search_btn reset_btn" @click="resetAndSearch()">초기화</button>
								</div>
							</div>
						</form>
					</div>
					<div class="sub_contBox">
						<!-- 자식 컴포넌트에 ref 추가 -->
						<Aiorder ref="aiorderComponent" :perPage="10" :func_print="true" :searchModels="searchModels" />
					</div>
				</div>
			</div>
		</div>
	</section>

	<include-footer />
</template>

<script>
import header from '../components/layout/header.vue'
import footer from '../components/layout/footer.vue'

export default {
	name: 'App',
	components: {
		'include-header': header,
		'include-footer': footer
	}
}
</script>

<script setup>
import { ref, computed, nextTick } from 'vue';
import * as globaljs from '@/components/utils/global';
import Aiorder from '@/components/layout/aiorder';

// 자식 컴포넌트를 참조하기 위해 ref 사용
const aiorderComponent = ref(null);

let other_type = ref(globaljs.acc_type === 'lab' ? "치과" : "기공소");

let searchModels = ref({
	progressSearch: '',
	aiorder_no: '',
	partner: '',
	orderDateSearch: '',
	orderDateSearch2: '',
	patientSearch: ''
});

// 자식 컴포넌트의 getModels 메서드를 호출하는 함수
const triggerChildGetModels = () => {
	if (aiorderComponent.value) {
		aiorderComponent.value.getModels();  // 올바르게 호출됨
	}
};

const searchReset = () => {
	searchModels.value = {
		progressSearch: '',
		aiorder_no: '',
		partner: '',
		orderDateSearch: '',
		orderDateSearch2: '',
		patientSearch: ''
	};
};

// 초기화 후 검색 실행 함수
const resetAndSearch = () => {
	searchReset();
	nextTick(() => {
		triggerChildGetModels();
	});
};

const isSearchActive = computed(() => {
	return Object.values(searchModels.value).some(value => value !== '');
});
</script>